export default ({
	methods: {
		sortBy(dataArg, colName) {
			let descending = false;
			let column = colName;

			if (colName.includes('desc')) {
				descending = true;
				column = colName.split(' ')[0];
			}

			dataArg.sort(function(res01, res02) {
				let arg01 = res01[column];
				let arg02 = res02[column];

				if(arg01 < arg02)
					return descending ? 1 : -1;

				if(arg01 > arg02)
					return descending ? -1 : 1;

				return 0;
			});

			return dataArg;
		}
	}
});
